import axios from 'axios';
import apiConfig from '../config/apiConfig';

export async function trackArticleOfferClick({
  articleId,
  offerId,
  language,
  url,
  title,
}) {
  if (!articleId || !url) return;
  try {
    await axios.post(`${apiConfig.BASE_URL}/articles/offers/click`, {
      articleId,
      offerId,
      language,
      url,
      title,
    });
  } catch {
    /* non-blocking */
  }
}
